import moment from 'moment';
import * as Output from '../../Text';
import { Rules } from '../technical';

const isThreeYearsFromNow = date => moment(date).isAfter(moment().subtract(3, 'years'));

export const prevStreetValidation = (field, fields) => {
  if (isThreeYearsFromNow(fields.residentSince)) {
    return (!field || field.length <= 0) ? Output.resolve('generic.errors.M001_mandatoryFields') : Rules.maxLength(30)(field)
  }
  return undefined;
};

export const prevHousenumberValidation = (field, fields) => (isThreeYearsFromNow(fields.residentSince) && (!field || field.length <= 0)
  ? Output.resolve('generic.errors.M001_mandatoryFields')
  : undefined);

export const prevPostCodeValidation = (field, fields) => (isThreeYearsFromNow(fields.residentSince) && (!field || field.length <= 0)
  ? Output.resolve('generic.errors.M001_mandatoryFields')
  : undefined);

export const prevCityValidation = (field, fields) => (isThreeYearsFromNow(fields.residentSince) && (!field || field.length <= 0)
  ? Output.resolve('generic.errors.M001_mandatoryFields')
  : Rules.maxLength(30)(field));

export const prevCountryValidation = (field, fields) => (isThreeYearsFromNow(fields.residentSince) && (!field || field.length <= 0)
  ? Output.resolve('generic.errors.M001_mandatoryFields')
  : undefined);
